import { InstanciaService } from './../../../../services/instancia.service';
import { Component, OnInit } from '@angular/core';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { Instancia } from '@app/models/processo.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-instancia-lista',
  templateUrl: './instancia-lista.component.html'
})
export class InstanciaListaComponent implements OnInit {

  instancias: Instancia[];
  bsModalRef: BsModalRef;

  constructor(
    private instanciaService: InstanciaService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.instanciaService.obterTodos().subscribe(data => {
      this.instancias = data;
    });
  }

  deletar(id: number): void {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir a instância: " + this.instancias.find(obj => obj.Id === id).Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.instanciaService.deletar(id).toPromise().then(
        () => {
          this.instanciaService.obterTodos().subscribe(data => {
            this.instancias = data;
          });
        }
      );
    }
  }
}
